import { Injectable, OnDestroy } from "@angular/core";
import { Graphics } from "../digital-twin/graphics/graphics";
import { GraphicsMultipleSelection } from "../digital-twin/graphics/graphics-multiple-selection";
import { DTSelectionService } from "../digital-twin/selection/selection.service";
import { AssetManager } from "./asset-manager";

@Injectable({ providedIn: 'root' })
export class AssetManagerMultipleSelection implements OnDestroy {
  constructor(
    private graphics: Graphics,
    private graphicsMultipleSelection: GraphicsMultipleSelection,
    private assetManager: AssetManager,
    private selectionService: DTSelectionService
  ) { }

  private _isActive: boolean = false;

  public get isActive(): boolean {
    return this._isActive;
  }
  public set isActive(value: boolean) {
    this._isActive = value;
  }

  private _showedSaveAllConfirmation: boolean = true;

  public get showedSaveAllConfirmation(): boolean {
    return this._showedSaveAllConfirmation;
  }
  public set showedSaveAllConfirmation(value: boolean) {
    this._showedSaveAllConfirmation = value;
  }

  public selectFirstElement() {
    if (this.assetManager.selectedInspections.length > 0) {
      this.selectionService.clearElementSelected(this.assetManager.currentSection?.Guid, this.assetManager.asset, false);
      this.selectionService.markElementSelected(this.assetManager.selectedInspections[0].Guid, this.assetManager.asset);
    }
  }

  public selectSecondaryElements() {
    if (this.assetManager.selectedInspections.length > 1) {
      let secElementIds = []
      for (let i = 1; i < this.assetManager.selectedInspections.length; i++) {
        secElementIds.push(this.assetManager.selectedInspections[i].Guid)
      }
      if (secElementIds.length > 0) {
        this.selectionService.markSecondaryElementsSelected(secElementIds, this.assetManager.asset)
      }
    }
  }

  public toggleMultipleSelection() {
    if (
      (this.assetManager.functionalityMode === 'INSPECTIONINSERTION' ||
        this.assetManager.functionalityMode === 'ELEMENTINSERTION' ||
        this.assetManager.functionalityMode === 'CRITICALAREA') &&
      (this.assetManager.asset.mode === 'SECTIONS' || (this.assetManager.asset.mode === 'REGIONS' && this.assetManager.functionalityMode === 'INSPECTIONINSERTION'))
    ) {
      this.graphicsMultipleSelection.selectedFilter = null;
      this.graphics.Controls.enableRotate = !this.graphics.Controls.enableRotate;
    } else if (
      this.assetManager.functionalityMode !== 'MULTIPLESELECTION' &&
      (this.assetManager.asset.mode === 'SECTIONS' || (this.assetManager.asset.mode === 'REGIONS' && this.assetManager.functionalityMode === 'INSPECTIONINSERTION'))
    ) {
      this.graphicsMultipleSelection.selectedFilter = null;
      this.assetManager.enableMultipleSelection();
    } else {
      this.assetManager.setFunctionalityModeNone();
    }
  }

  public initializeSelectionArea(): void {
    this.graphicsMultipleSelection.threeStartGeometryCloning();
    this.graphics.rectd.startRectangleSelection = true;
    this.showedSaveAllConfirmation = false;
  }

  public nextMeasurementInsertion(element): void {
    this.graphicsMultipleSelection.setNextSelectedPointActive(element);
  }

  ngOnDestroy(): void {
    throw new Error("Method not implemented.");
  }

}
